/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class ETransportNotificationDetailsMetadataModel extends JSONable {
  totalGrossWeight: number | null = null;
  totalNetWeight: number | null = null;
  totalValue: number | null = null;
  commPartnerPartnerBusinessProfileUuid: string | null = null;
  shipOrgPartnerBusinessProfileUuid: string | null = null;
}
